<template>
  <footer>
    <div
      class="max-w-[1220px] mx-auto lg:rounded-t-[40px] lg:mb-[60px] py-[33px] px-[47px] lg:py-[55px] lg:px-[60px] z-50"
      :class="variant==='light' ? 'bg-[#FFC107]' : 'bg-white'"
    >
      <div class="flex flex-col items-center md:items-start">
        <div class="lg:pb-[66px] pb-[33px]">
          <NuxtLink :to="localePath('/')">
            <Logo />
          </NuxtLink>
        </div>
        <div class="flex flex-col lg:flex-row lg:gap-x-[80px] ">
          <div class="flex md:gap-x-[80px] flex-col gap-y-[27px] mb-[27px] md:mb-0 md:flex-row md:gap-y-0">
            <div class="max-w-[246px]">
              <p class="font-nutino text-[18px] mt-[27px]">
                {{ t('b2b.footer.description') }}
              </p>
            </div>
            <div>
              <span class="px-[6px] py-[1px] bg-[#FFC107] text-black font-nutino font-medium text-[20px] rounded-md">
                {{ t('b2b.footer.titles.1') }}
              </span>
              <nav class="mt-[27px]">
                <ul class="flex flex-col gap-y-[16px]">
                  <li>
                    <NuxtLink :to="localePath('/agreement')" class="font-avenir text-[18px] underline hover:no-underline">
                      {{ t('b2b.footer.menu.0') }}
                    </NuxtLink>
                  </li>
                  <li>
                    <NuxtLink :to="localePath('/privacy')" class="font-avenir text-[18px] underline hover:no-underline">
                      {{ t('b2b.footer.menu.3') }}
                    </NuxtLink>
                  </li>
                  <li>
                    <NuxtLink :to="localePath('/contacts')" class="font-avenir text-[18px] underline hover:no-underline">
                      {{ t('b2b.footer.menu.4') }}
                    </NuxtLink>
                  </li>
                  <li>
                    <NuxtLink :to="localePath('/about-us')" class="font-avenir text-[18px] underline hover:no-underline">
                      {{ t('b2b.footer.menu.5') }}
                    </NuxtLink>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
          <div>
            <span class="px-[6px] py-[1px] bg-[#FFC107] text-black font-nutino font-medium text-[20px] rounded-md">
              {{ t('b2b.footer.titles.2') }}
            </span>
            <div class="mt-[27px] flex flex-col space-y-5">
              <a href="https://www.linkedin.com/company/betobee-ua" target="_blank" class="hover:underline">
                <Icon name="skill-icons:linkedin" /> LinkedIn
              </a>
              <div v-for="key in ['support', 'partners', 'invest', 'hr']">
                <p class="font-bold">{{ t(`b2b.footer.contacts.${key}`) }}</p>
                <a :href="`mailto:${key}@betobee.com.ua`" class="underline hover:no-underline">{{ key }}@betobee.com.ua</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import Logo from './icons/Logo.vue';

const { t } = useI18n();
const localePath = useLocalePath();

type TVariants = 'light' | 'dark';

interface Props {
  variant?: TVariants;
}

withDefaults(defineProps<Props>(), {
  variant: 'dark'
})

</script>


